var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.66699C7.70251 1.66699 5.83334 3.53616 5.83334 5.83366V8.33366H5.00001C4.55798 8.33366 4.13406 8.50925 3.8215 8.82181C3.50894 9.13438 3.33334 9.5583 3.33334 10.0003V16.667C3.33334 17.109 3.50894 17.5329 3.8215 17.8455C4.13406 18.1581 4.55798 18.3337 5.00001 18.3337H15C15.442 18.3337 15.866 18.1581 16.1785 17.8455C16.4911 17.5329 16.6667 17.109 16.6667 16.667V10.0003C16.6667 9.5583 16.4911 9.13438 16.1785 8.82181C15.866 8.50925 15.442 8.33366 15 8.33366H14.1667V5.83366C14.1667 3.53616 12.2975 1.66699 10 1.66699ZM7.50001 5.83366C7.50001 4.45533 8.62168 3.33366 10 3.33366C11.3783 3.33366 12.5 4.45533 12.5 5.83366V8.33366H7.50001V5.83366ZM10.8333 14.7695V16.667H9.16668V14.7695C8.87533 14.6027 8.64139 14.3514 8.4957 14.049C8.35001 13.7465 8.29941 13.4069 8.35058 13.0751C8.40175 12.7433 8.55227 12.4348 8.78231 12.1903C9.01235 11.9457 9.31111 11.7767 9.63918 11.7053C9.88286 11.6514 10.1355 11.653 10.3785 11.7097C10.6216 11.7665 10.8487 11.8771 11.0433 12.0334C11.2379 12.1897 11.3949 12.3876 11.5028 12.6127C11.6107 12.8377 11.6667 13.0841 11.6667 13.3337C11.6662 13.6251 11.5889 13.9113 11.4426 14.1634C11.2963 14.4154 11.0862 14.6245 10.8333 14.7695Z",
    fill: "#F31260"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoLock);
export default __webpack_public_path__ + "static/media/info-lock.39232314ea14f55e189f49a3172ab559.svg";
export { ForwardRef as ReactComponent };